import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Spinner } from '@/components/ui/Spinner'
import { useAuth } from '@/features/auth/store'

/**
 * Route guard for everything behind sign-in.
 *
 * Redirects carry the attempted path in router state, so a user who follows a deep link
 * while signed out lands back on it after signing in rather than on the dashboard.
 */
export function RequireAuth() {
  const status = useAuth((s) => s.status)
  const location = useLocation()

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center" aria-busy="true">
        <Spinner className="h-6 w-6 text-slate-400" />
        <span className="sr-only">Restoring your session</span>
      </div>
    )
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  return <Outlet />
}
